import React from "react";
import styles from "./styles.module.scss";

interface LegendEntry {
  value: string;
  color: string;
  dataKey?: string;
}

interface CustomLegendProps {
  payload: LegendEntry[];
}

const CustomLegend: React.FC<CustomLegendProps> = ({ payload }) => {
  return (
    <div className={styles.customLegendContainer}>
      {payload.map((entry) => {
        const key = entry.dataKey ?? entry.value;
        return (
          <div key={key} className={styles.legendItem}>
            <span
              className={styles.legendDot}
              style={{ backgroundColor: entry.color }}
            />
            <span className={styles.legendText}>{entry.value}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CustomLegend;
